import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { IMAGES } from '../data/mock';

export const SectionTitle = ({ kicker, title, center, light, className = '' }) => (
  <div className={`${center ? 'text-center mx-auto max-w-2xl' : ''} ${className}`}>
    {kicker && (
      <div className={`inline-block text-sm font-bold uppercase tracking-widest mb-3 ${light ? 'text-brand-green' : 'text-brand-green'}`}>{kicker}</div>
    )}
    <h2 className={`font-display font-extrabold text-3xl md:text-4xl leading-tight ${light ? 'text-white' : 'text-brand-bluedark'}`}>{title}</h2>
    <div className={`h-1 w-20 bg-brand-green rounded-full mt-4 ${center ? 'mx-auto' : ''}`} />
  </div>
);

export const PageHero = ({ title, subtitle, crumb }) => (
  <section className="relative bg-brand-bluedeep overflow-hidden">
    <div className="absolute inset-0">
      <img src={IMAGES.mountains} alt="" className="w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-r from-brand-bluedeep via-brand-bluedeep/90 to-brand-bluedark/70" />
    </div>
    <div className="container-c relative py-20 md:py-28">
      <div className="flex items-center gap-2 text-sm text-white/60 mb-4">
        <Link to="/" className="hover:text-brand-green">Home</Link>
        <ChevronRight size={14} />
        <span className="text-brand-green">{crumb || title}</span>
      </div>
      <h1 className="font-display font-extrabold text-4xl md:text-5xl text-white max-w-3xl leading-tight">{title}</h1>
      {subtitle && <p className="text-white/80 text-lg mt-4 max-w-2xl">{subtitle}</p>}
    </div>
  </section>
);

export const CurveDivider = ({ color = '#ffffff' }) => (
  <div className="curve-divider">
    <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="w-full h-12 md:h-20">
      <path fill={color} d="M0,80 L0,40 Q720,-40 1440,40 L1440,80 Z" />
    </svg>
  </div>
);
